// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsArray, ValidateNested, IsInt, IsString, IsNotEmpty, ArrayNotEmpty } from 'class-validator';

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class EditBlockForm {
  @ArrayNotEmpty()
  @IsArray()
  @ValidateNested({ each: true })
  templates: TemplateForm[];
}
